
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueResource from 'vue-resource'

import messages from './i18n'
import store from './store'

import ChatboxWrapper from './ChatboxWrapper.vue'
// TO BE MOVED WITH THE FUTURE CHANNELS NPM PACKAGE (Vue component install)
import webchat from '@/store/modules/webchat'

declare global {
  interface Navigator {
    userLanguage?: string;
  }
  interface Window {
    webpackHotUpdate?: string;
  }
}

Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(VueResource)
Vue.http.options.root = `${process.env.VUE_APP_BACKEND_URL}`

const i18n = new VueI18n({
  locale: (navigator.language || navigator.userLanguage || '').split('-')[0],
  fallbackLocale: 'en',
  messages // set locale messages
})

const urlParams = new URLSearchParams(window.location.search)
const account: string | null = urlParams.get('account')
const skill: string | null = urlParams.get('skill')
let url = `${process.env.VUE_APP_BACKEND_URL}/widget/v2/${account}`

if (skill) {
  url += `/${skill}`
}

Vue.http.get(url)
  .then((response: Response) => response.json())
  .then((params: any) => {
    if (params.is_open === true) {
      params.channels = params.channels.filter((c: any) => c.name === 'web_chat')

      new Vue({
        i18n,
        store,
        render: h => h(ChatboxWrapper),
        beforeMount () {
          params.httpUrl = `${process.env.VUE_APP_BACKEND_URL}`
          params.wsUrl = `${process.env.VUE_APP_BACKEND_WS}`
          params.uploadUrl = `${process.env.VUE_APP_UPLOAD_URL}`
          this.$store.commit('setAccount', account)
          this.$store.commit('initial', params)
          this.$store.commit('setChannels', params.channels)

          // TO BE MOVED WITH THE FUTURE CHANNELS NPM PACKAGE (Vue component install)
          this.$store.registerModule('webchat', webchat)
        }
      }).$mount('#app')
    }
  })
